import camelCase from 'lodash/camelCase';
import React from 'react';

import { Spacing } from './Spacing';

const marginProps = ['margin-top', 'margin-right', 'margin-bottom', 'margin-left'];
const paddingProps = ['padding-top', 'padding-right', 'padding-bottom', 'padding-left'];

const getSpacingValues = (cssRule: string, mappingArray: string[]) => {
  const result: Record<string, string> = {};
  const array = cssRule.split(' ');
  mappingArray.forEach((prop, index) => {
    const value = array[index] ?? '0px';
    result[camelCase(prop)] = value.replace('px', '');
  });
  return result;
};

type SpacingPickerProps = {
  padding: string;
  margin: string;
  disabled?: boolean;
  noMargin?: boolean;
  onUpdate: (margin: string, padding: string) => void;
};

export const SpacingPicker = ({
  margin,
  padding,
  disabled,
  noMargin,
  onUpdate,
}: SpacingPickerProps) => {
  const camelCaseSpacingProps = {
    ...getSpacingValues(margin, marginProps),
    ...getSpacingValues(padding, paddingProps),
  };

  const inlineCss = (rules: string[], values: Record<string, string | number>): string =>
    rules
      .reduce((cssProp, rule) => `${cssProp} ${values[camelCase(rule) ?? ''] ?? 0}px`, '')
      .trim();

  const setSpacingValue = (cssUpdate: Record<string, string | number>) => {
    const updatedValues = { ...camelCaseSpacingProps, ...cssUpdate };

    const inlineMargin = inlineCss(marginProps, updatedValues);
    const inlinePadding = inlineCss(paddingProps, updatedValues);

    onUpdate(inlineMargin, inlinePadding);
  };

  return (
    <>
      <Spacing
        noMargin={noMargin}
        disabled={disabled}
        properties={camelCaseSpacingProps}
        setProperties={setSpacingValue}
      />
    </>
  );
};
